import React, { useEffect, useState } from "react";
import LoadingButton from "../../../../components/customMui/LoadingButton";
import Alert from "../../../../components/customMui/Alert";
import { Skeleton } from "@mui/material";
import PracticeAnswer from "../practiceAnswer/PracticeAnswer";
import "./practiceQuestionAnswer.css";

const PracticeQuestionAnswerDomain = ({
    questionAnswerData,
    isLastQuestion,
    onAnswerSubmit,
    onNextQuestion,
    showPageLoader
}) => {
    const [ formattedQuestionAnswer, setFormattedQuestionAnswer ] = useState(null);
    const [ selectedOption, setSelectedOption ] = useState(null);
    const [ submitAnswerLoader, setSubmitAnswerLoader ] = useState(false);
    const [ nextQuestionLoader, setNextQuestionLoader ] = useState(false);
    const [ answerResult, setAnswerResult ] = useState(null);

    useEffect(() => {
        if (questionAnswerData) {
            handleFormatQuestionAnswer();
        }
    }, [questionAnswerData])

    const handleFormatQuestionAnswer = () => {
        let newFormattedQuestionAnswer = {
            question_text: questionAnswerData.text,
            options: [],
        }
        for (const optionKey in questionAnswerData.options) {
            newFormattedQuestionAnswer.options.push({
                key: optionKey,
                name: questionAnswerData.options[optionKey]
            })
        }
        setFormattedQuestionAnswer(newFormattedQuestionAnswer);
    }

    const handleSelectOption = option => {
        if (submitAnswerLoader || answerResult) return;
        if (selectedOption === option) {
            setSelectedOption(null);
            return;
        }
        setSelectedOption(option);
    }

    const handleSubmitAnswer = async () => {
        if (submitAnswerLoader) return;
        setSubmitAnswerLoader(true);
        const submitAnswerRes = await onAnswerSubmit(selectedOption);
        if (submitAnswerRes) {
            setAnswerResult(submitAnswerRes);
        }
        setSubmitAnswerLoader(false);
    }

    const handleNextQuestion = async () => {
        setNextQuestionLoader(true);
        const nextQuestionRes = await onNextQuestion();
        if (nextQuestionRes) {
            setAnswerResult(null);
            setSelectedOption(null);
        }
        setNextQuestionLoader(false);
    }

    const getAnswerState = (option) => {
        if (answerResult) {
            if (option === answerResult.selection.correct_answer) {
                return "correct";
            }
            if (option == selectedOption && answerResult.qstate_current === "answer_fail") {
                return "incorrect";
            }
            return "disabled";
        }
        if (submitAnswerLoader) {
            if (option != selectedOption) {
                return "disabled";
            }
        }
        if (option == selectedOption) {
            return "selected";
        }
        return "";
    }
    if (showPageLoader || !formattedQuestionAnswer) {
        return (
            <div style={{ width: "100%" }}>
                <Skeleton animation="wave" sx={{ width: "95%", marginTop: "15px" }} />
                <Skeleton animation="wave" sx={{ width: "98%" }} />
                <Skeleton animation="wave" sx={{ width: "92%" }} />
                <Skeleton animation="wave" sx={{ width: "95%" }} />
                <Skeleton animation="wave" sx={{ width: "65%", marginBottom: "30px" }} />

                <PracticeAnswer answerState="loading" />
                <PracticeAnswer answerState="loading" />
                <PracticeAnswer answerState="loading" />
                <PracticeAnswer answerState="loading" />

                <Skeleton animation="wave" sx={{ width: "100%", marginTop: "30px", height: "70px" }} />
            </div>
        )
    }

    return (
        <div style={{ width: "100%" }}>
            <p style={{ marginBottom: "10px" }}>{formattedQuestionAnswer.question_text}</p>
            <div className="practice-qa-answer-container">
                {formattedQuestionAnswer.options.map((option, index) => {
                    return (    
                        <div key={index}>                
                            <PracticeAnswer 
                                answerData={option}
                                answerState={getAnswerState(option.key)} 
                                onClick={(key) => handleSelectOption(key)}
                            />
                        </div>
                    )
                })}
            </div>
            {!answerResult ? (
                <div className="practice-qa-answer-button-container">
                    <LoadingButton 
                        customProps={{
                            onClick: handleSubmitAnswer,
                            loading: submitAnswerLoader,
                            disabled: !selectedOption || submitAnswerLoader
                        }}
                    >
                        Submit
                    </LoadingButton>
                </div>
            ) : (
                <>
                    <div className="practice-qa-next-button-container">
                        <LoadingButton 
                            customProps={{
                                onClick: handleNextQuestion,
                                loading: nextQuestionLoader
                            }}
                        >
                            {!isLastQuestion ? "Next Question" : "View Results"}
                        </LoadingButton>
                    </div>
                    <Alert severity={answerResult.qstate_current === "answer_fail" ? "error" : "success"}>
                        {answerResult.qstate_current === "answer_fail" ? (
                            <p>
                                Incorrect, the correct answer is&nbsp;
                                <span className="font-header-regular">{answerResult.selection.correct_answer.toUpperCase()}</span>
                            </p>                            
                        ) : (
                            <p>Correct!</p>
                        )}
                                {/* {answerResult.domain_name ? (
                                <p className="font-color-regular">
                                    <span className="font-header-bold">Domain:</span>&nbsp;
                                    {(() => {
                                        const regex = /Domain\s(\d+):\s*(.+)/; 
                                        const match = regex.exec(answerResult.domain_name);
                                        if (match) {
                                            const number = match[1]; 
                                            const text = match[2];
                                            return `${number}.${text}`; 
                                        }
                                    })()}
                                </p>
                            ) : null} */}
                        {answerResult.topic_key ? (
                            <p className="font-color-regular">
                                <br />
                                <span className="font-header-bold">Topic:</span>&nbsp;
                                {answerResult.topic_key}
                            </p>
                        ) : null}
                            
                        {answerResult.explanation ? (
                            <p className="font-color-regular">
                                <br />
                                <span className="font-header-bold">Explanation:</span>&nbsp;
                                {answerResult.explanation}
                            </p>
                        ) : null}
                        {answerResult.why_not ? (
                            <p className="font-color-regular">
                                <br />
                                <span className="font-header-bold">Why not:</span>&nbsp;
                                {answerResult.why_not}
                            </p>
                        ) : null}
                    </Alert>                    
                </>
            )}

        </div>
    )
}

export default PracticeQuestionAnswerDomain;
